export default class Event {
	constructor({
		id,
		name,
		is_date_event,
		end_date,
		start_date,
		is_seated,
		organizer_id,
		is_closed,
		organization,
		organization_ids,
		event_config
	} = {}) {
		this.id = id;
		this.name = name;
		this.isDateEvent = is_date_event;
		this.endDate = end_date;
		this.startDate = start_date;
		this.isSeated = is_seated;
		this.organizerId = organizer_id;
		this.isClosed = is_closed;
		this.organization = organization;
		this.organizationIds = organization_ids;
		this.event_config = event_config;
	}

	getId() {
		return this.id;
	}

	getIsDateEvent() {
		return this.isDateEvent;
	}

	getEndDate() {
		return this.endDate;
	}

	getStartDate() {
		return this.startDate;
	}

	getName() {
		return this.name;
	}

	getIsSeated() {
		return this.isSeated;
	}

	getOrganizerId() {
		return this.organizerId;
	}

	getIsClosed() {
		return this.isClosed;
	}

	getOrganization() {
		return this.organization;
	}
	static buildFromJSON(json) {
		return new Event({
			id: json.id,
			name: json.name,
			is_date_event: json.is_date_event,
			end_date: json.end_date,
			start_date: json.start_date,
			is_seated: json.is_seated,
			organizer_id: json.organizer_id,
			is_closed: json.is_closed,
			organization: json.organization,
			organization_ids: json.organization_ids,
			event_config: json.event_config
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			is_date_event: this.isDateEvent,
			end_date: this.endDate,
			start_date: this.startDate,
			is_seated: this.isSeated,
			organizer_id: this.organizerId,
			is_closed: this.isClosed,
			organization: this.organization,
			organization_ids: this.organizationIds
		};
	}
}
